var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 6.8V11.3H11.3V6.8H6.8ZM13.1 11.3C13.1 12.2941 12.2941 13.1 11.3 13.1H6.8C5.80589 13.1 5 12.2941 5 11.3V6.8C5 5.80589 5.80589 5 6.8 5H11.3C12.2941 5 13.1 5.80589 13.1 6.8V11.3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 16.7V21.2H11.3V16.7H6.8ZM13.1 21.2C13.1 22.1941 12.2941 23 11.3 23H6.8C5.80589 23 5 22.1941 5 21.2V16.7C5 15.7059 5.80589 14.9 6.8 14.9H11.3C12.2941 14.9 13.1 15.7059 13.1 16.7V21.2Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 6.8V11.3H21.2V6.8H16.7ZM23 11.3C23 12.2941 22.1941 13.1 21.2 13.1H16.7C15.7059 13.1 14.9 12.2941 14.9 11.3V6.8C14.9 5.80589 15.7059 5 16.7 5H21.2C22.1941 5 23 5.80589 23 6.8V11.3Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 14.9H15.35C15.1015 14.9 14.9 15.1015 14.9 15.35V17.15C14.9 17.3985 15.1015 17.6 15.35 17.6H17.15C17.3985 17.6 17.6 17.3985 17.6 17.15V15.35C17.6 15.1015 17.3985 14.9 17.15 14.9Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.85 17.6H18.05C17.8015 17.6 17.6 17.8015 17.6 18.05V19.85C17.6 20.0985 17.8015 20.3 18.05 20.3H19.85C20.0985 20.3 20.3 20.0985 20.3 19.85V18.05C20.3 17.8015 20.0985 17.6 19.85 17.6Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.55 14.9H20.75C20.5015 14.9 20.3 15.1015 20.3 15.35V17.15C20.3 17.3985 20.5015 17.6 20.75 17.6H22.55C22.7985 17.6 23 17.3985 23 17.15V15.35C23 15.1015 22.7985 14.9 22.55 14.9Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.55 20.3H20.75C20.5015 20.3 20.3 20.5015 20.3 20.75V22.55C20.3 22.7985 20.5015 23 20.75 23H22.55C22.7985 23 23 22.7985 23 22.55V20.75C23 20.5015 22.7985 20.3 22.55 20.3Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.15 20.3H15.35C15.1015 20.3 14.9 20.5015 14.9 20.75V22.55C14.9 22.7985 15.1015 23 15.35 23H17.15C17.3985 23 17.6 22.7985 17.6 22.55V20.75C17.6 20.5015 17.3985 20.3 17.15 20.3Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownApp);
export default __webpack_public_path__ + "static/media/down-app.541608548f6d31b3d712facb671dc4ce.svg";
export { ForwardRef as ReactComponent };